export default {"src":"/_next/static/media/whatsapp.58995dbc.svg","height":28,"width":28};